import { createFileRoute } from '@tanstack/react-router'
import { CampaignEditRoutePage } from '@/features/operations/pages/campaign-edit-route-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/campaigns/$id/')({
  beforeLoad: requireRole(['admin']),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <CampaignEditRoutePage campaignId={id} />
}
